import React from "react"

const LayoutControlsHeader = (props) => {
   const {componentName} = props.stack.config.content[props.stackIndex].gridHeader || {};
   let Component = null ;
   try {
     Component =  props.stack.layoutManager.getComponent(componentName);
   } catch(error){
       console.error("Header component load error", error)
   }
   if(!Component){
       return null
   } 
   return  (
        <Component {...props}/>
    )
}

export default LayoutControlsHeader;